// Shared constants & label helpers
import i18n from '../i18n';

export const TAGS = [
  { key: 'lead_freddo_non_qualificato', label: 'Lead freddo', color: 'slate' },
  { key: 'ha_visto_vsl', label: 'Ha visto VSL', color: 'emerald' },
  { key: 'non_ha_visto_vsl', label: 'Non ha visto VSL', color: 'sand' },
  { key: 'ha_compilato_modulo', label: 'Modulo compilato', color: 'teal' },
  { key: 'ha_prenotato_call', label: 'Call prenotata', color: 'sky' },
  { key: 'no_show_call', label: 'No-show call', color: 'coral' },
  { key: 'candidato_evento', label: 'Candidato evento', color: 'gold' },
  { key: 'selezionato_evento', label: 'Selezionato evento', color: 'olive' },
  { key: 'non_idoneo', label: 'Non idoneo', color: 'rose' },
  { key: 'riattivazione', label: 'Riattivazione', color: 'lavender' },
];

export const TAG_COLORS = {
  emerald: { bg: '#D7EFE6', fg: '#0C3C2D' },
  teal: { bg: '#D6F0F0', fg: '#0E5A5A' },
  sand: { bg: '#F1E7D6', fg: '#5A4630' },
  gold: { bg: '#F3E7C7', fg: '#6A4B00' },
  sky: { bg: '#DCECF4', fg: '#2F7EA0' },
  coral: { bg: '#F6E0D8', fg: '#8A2F1A' },
  olive: { bg: '#E6EBD8', fg: '#3E4A1F' },
  lavender: { bg: '#EAE6F6', fg: '#3B2F6A' },
  slate: { bg: '#E7ECEF', fg: '#1F2A37' },
  rose: { bg: '#F7E3EA', fg: '#7A1F3D' },
};

export function tagDef(key) {
  return TAGS.find((t) => t.key === key) || { key, label: key, color: 'slate' };
}

export const BRANCH_LABELS = {
  pre_branch: 'Pre-branch',
  equity_estate: 'Equity Estate',
  real_estate: 'Real Estate',
};

export const BRANCH_COLORS = {
  pre_branch: { bg: '#F1E7D6', fg: '#5A4630' },
  equity_estate: { bg: '#DCECF4', fg: '#2F7EA0' },
  real_estate: { bg: '#D6F0F0', fg: '#0E5A5A' },
};

export const SOURCE_LABELS = new Proxy({
  meta: 'Meta Ads',
  tiktok: 'TikTok Ads',
  google: 'Google Ads',
  manual: 'Inserimento manuale',
  modulo2: 'Modulo 2 (Public)',
  csv: 'Import CSV',
  api: 'API',
  booking: 'Calendar',
}, {
  get(target, prop) {
    // ★ 2026-08-27 (Fase 56.1) — translate source labels on the fly.
    // `SOURCE_LABELS['manual']` → i18n string per current language.
    if (typeof prop === 'string' && Object.prototype.hasOwnProperty.call(target, prop)) {
      const fallback = target[prop];
      try {
        return i18n.t(`common.sourceLabels.${prop}`, fallback);
      } catch {
        return fallback;
      }
    }
    return target[prop];
  },
});

// ★ Fase 32 — etichette ruolo localizzate (getter → valutate a runtime,
// così rispettano la lingua attiva dell'utente).
export const ROLE_LABELS = {
  get admin() { return i18n.t('roles.admin', 'Admin'); },
  get commerciale() { return i18n.t('roles.commerciale', 'Commerciale'); },
  get legale() { return i18n.t('roles.legale', 'Legale'); },
  get amministrativo() { return i18n.t('roles.amministrativo', 'Amministrativo'); },
};

export function fmtRelative(iso) {
  if (!iso) return '—';
  const d = new Date(iso);
  const diff = (Date.now() - d.getTime()) / 1000;
  const lang = (i18n.language || 'it').split('-')[0];
  // ★ 2026-08-27 (Fase 56.1) — localized relative time strings.
  const now = i18n.t('common.relTime.now', 'ora');
  const minAgo = (n) => i18n.t('common.relTime.minAgo', '{{n}} min fa', { n });
  const hAgo = (n) => i18n.t('common.relTime.hAgo', '{{n}} h fa', { n });
  const dAgo = (n) => i18n.t('common.relTime.dAgo', '{{n}} g fa', { n });
  if (diff < 60) return now;
  if (diff < 3600) return minAgo(Math.floor(diff / 60));
  if (diff < 86400) return hAgo(Math.floor(diff / 3600));
  if (diff < 86400 * 7) return dAgo(Math.floor(diff / 86400));
  const localeMap = { it: 'it-IT', en: 'en-GB', es: 'es-ES', no: 'nb-NO', ru: 'ru-RU' };
  return d.toLocaleDateString(localeMap[lang] || 'it-IT', { day: '2-digit', month: 'short' });
}

export function fmtDateTime(iso) {
  if (!iso) return '—';
  const d = new Date(iso);
  const lang = (i18n.language || 'it').split('-')[0];
  const localeMap = { it: 'it-IT', en: 'en-GB', es: 'es-ES', no: 'nb-NO', ru: 'ru-RU' };
  return d.toLocaleString(localeMap[lang] || 'it-IT', { day: '2-digit', month: 'short', year: 'numeric', hour: '2-digit', minute: '2-digit' });
}

export function scoreColor(score) {
  if (score == null) return { bg: '#E7ECEF', fg: '#1F2A37', label: 'N/D' };
  if (score >= 80) return { bg: '#D7EFE6', fg: '#0C3C2D', label: 'HOT' };
  if (score >= 50) return { bg: '#F3E7C7', fg: '#6A4B00', label: 'WARM' };
  return { bg: '#E7ECEF', fg: '#1F2A37', label: 'COLD' };
}
